// @core/api/endpoints/booking/start_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  StartBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Start booking
 * Marks a booking as IN_PROGRESS (check-in). Validates the current time is within the booking window per no-show grace period.
 */
export async function StartBooking(
  target_type: string,
  target_id: string,
  data: StartBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/start`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
